import {
  getRequest,
  postRequest,
  patchRequest,
  uploadEncodedFile,
  deleteRequest,
} from "NetworkCall";
import { INSTANCE_URL, BASE_IMAGES_URL } from "Constants";

import { randomstring } from "randomstring-js";
import _ from "lodash";

export var CONTENT_CATEGORY_LIST = "CONTENT_CATEGORY_LIST";
export var CONTENT_EVENTGUIDE_LIST = "CONTENT_EVENTGUIDE_LIST";
export var LOAD_EDIT_EVENTGUIDE_DATA = "LOAD_EDIT_EVENTGUIDE_DATA";
export var OPEN_EVENTGUIDE_MODAL = "OPEN_EVENTGUIDE_MODAL";
export var EVENTGUIDE_MAX_DISPLAYORDER = "EVENTGUIDE_MAX_DISPLAYORDER";
export var EVENTGUIDE_FILE_LIST = "EVENTGUIDE_FILE_LIST";
export var UPDATE_EVENTGUIDE_FILES = "UPDATE_EVENTGUIDE_FILES";
export var EVENTGUIDE_FILES_CHANGED = "EVENTGUIDE_FILES_CHANGED";
export var UPDATE_VARIATION_FILES = "UPDATE_VARIATION_FILES";

// FETCH CATEGORY LIST (doc_faqs)
export function fetchCatgoryList(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventguide_admin_script`;

  return (dispatch) => {
    postRequest(
      url,
      {
        requesttype: "fetchCategoryList",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        dispatch({
          type: CONTENT_CATEGORY_LIST,
          payload: {
            data: response.resource.data,
            count: response.resource.data ? response.resource.data.length : 0,
          },
        });
        callback({ status: 1 });
      },
      (error) => {
        // Old codes state: 0;
        callback({ status: 1 });
      }
    );
  };
}

// EVENTGUIDE LIST FETCH
export function fetchEventGuideList(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventguide_admin_script`;

  return (dispatch) => {
    postRequest(
      url,
      {
        requesttype: "fetcheventguidelist",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        dispatch({
          type: CONTENT_EVENTGUIDE_LIST,
          payload: {
            data: response.resource.data,
            count: response.resource.data.length,
          },
        });
        callback({ status: 1 });
      },
      (error) => {
        // Old codes state: 0;
        callback({ status: 0 });
      }
    );
  };
}

// Update Dispaly Category Order by Dragging List Of category
export function updateEventGuideCategoryList(
  session,
  newArrAvailable,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventguide_admin_script`;

  return (dispatch) => {
    dispatch({
      type: CONTENT_CATEGORY_LIST,
      payload: { data: newArrAvailable, count: newArrAvailable.length },
    });

    postRequest(
      url,
      {
        requesttype: "updateeventguidecategory",
        eventid: session.eventid,
        newArrAvailable: newArrAvailable,
      },
      session,
      dispatch,
      (response) => {
        dispatch({
          type: CONTENT_EVENTGUIDE_LIST,
          payload: {
            data: response.resource.data1,
            count: response.resource.data1.length,
          },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

// Update Display Order by Draginng List Row
export function updateEventGuideList(session, newArrAvailable, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventguide_admin_script`;

  return (dispatch) => {
    postRequest(
      url,
      {
        requesttype: "updateeventguide",
        eventid: session.eventid,
        newArrAvailable: newArrAvailable,
      },
      session,
      dispatch,
      (response) => {
        dispatch({
          type: CONTENT_EVENTGUIDE_LIST,
          payload: {
            data: response.resource.data1,
            count: response.resource.data1.length,
          },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

// Load Edit eventguides
export function loadEditeventguidesData(eventguides) {
  if (Object.keys(eventguides).length > 0) {
    eventguides = {
      ...eventguides,
      [eventguides.id]: eventguides.displayorder,
    };

    return {
      type: LOAD_EDIT_EVENTGUIDE_DATA,
      payload: eventguides,
    };
  } else {
    return {
      type: LOAD_EDIT_EVENTGUIDE_DATA,
      payload: {},
    };
  }
}

// Open Modal
export function openEventGuideModal(option) {
  return {
    type: OPEN_EVENTGUIDE_MODAL,
    payload: option,
  };
}

// Get max DISPLAYORDER number
export function getMaxDisplayorder(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventguide_admin_script`;

  return (dispatch) => {
    postRequest(
      url,
      {
        requesttype: "getmaxdisplayorder",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        dispatch({
          type: EVENTGUIDE_MAX_DISPLAYORDER,
          payload: { data: response.resource.data },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

// Event Guide File Fetch
export function fetchEventguideFileList(session, speakerid) {
  return (dispatch) => {
    var url = `${INSTANCE_URL}/api/v2/eventify/_table/speakerfiles?filter=speakerid=${speakerid}`;
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: EVENTGUIDE_FILE_LIST, payload: data });
      },
      (error) => {
        // nothing to do
      }
    );
  };
}

export function updateEventGuideFiles(file) {
  return (dispatch) => {
    dispatch({ type: UPDATE_EVENTGUIDE_FILES, payload: file });
  };
}

// File Change
export function filesChanged(bool) {
  return (dispatch) => {
    dispatch({ type: EVENTGUIDE_FILES_CHANGED, payload: bool });
  };
}

// Insert Event Guide with files

export function insertEventguide(
  maxDisplayorderVal,
  session,
  values,
  eventguide,
  filechanged,
  uploadFiles,
  callback
) {
  //debugger;
  var eventid = session.eventid;
  values = { ...values, eventid };
  values = _.omit(values, [values.id]);

  return (dispatch) => {
    if (filechanged.ischanged) {
      _uploadAttachedFiles(session, uploadFiles, dispatch, (attachments) => {
        values = {
          ...values,
          file1: attachments[0].file,
          file2: attachments[1].file,
          file3: attachments[2].file,
          file4: attachments[3].file,
          file5: attachments[4].file,
          file6: attachments[5].file,
          file7: attachments[6].file,
          file8: attachments[7].file,
          file9: attachments[8].file,
          file10: attachments[9].file,
        };
        _createUpdateEventguide(
          maxDisplayorderVal,
          session,
          values,
          eventguide,
          dispatch,
          (feedback) => {
            if (feedback.success) {
              dispatch();
            } else {
              callback({ error: 0, data: feedback.data });
            }
          }
        );
      });
    } else {
      values = { ...values };

      _createUpdateEventguide(
        maxDisplayorderVal,
        session,
        values,
        eventguide,
        dispatch,
        (feedback) => {
          if (feedback.success) {
            dispatch();
          } else {
            callback({ error: 0, data: feedback.data });
          }
        }
      );
    }
  };
}

export function _uploadAttachedFiles(session, uploadFiles, dispatch, callback) {
  var promiseArray = [];
  var eventid = session.eventid;
  _.map(uploadFiles, (item, index) => {
    promiseArray.push(
      new Promise((resolve, reject) => {
        var file = item.file;
        var name = item.filename;
        var n = file.search(";base64,");
        if (n > 0) {
          var content = file.split(";base64,")[1];
          var fileCustomName = name.substr(0, name.lastIndexOf("."));
          var fileType = name.split(".").pop();

          var filename = `eventify/${eventid}/files/eventguide/${fileCustomName}_${randomstring(
            32
          )}.${fileType}`;
          var imageJson = {
            resource: [
              {
                name: filename,
                type: "file",
                is_base64: true,
                content: content,
              },
            ],
          };
          uploadEncodedFile(
            `${BASE_IMAGES_URL}?check_exist=false`,
            session,
            imageJson,
            dispatch,
            (data) => {
              uploadFiles[index].file = data.name;
              resolve();
            },
            (error) => {
              // callback({success:2, message:error});
            }
          );
        } else if (file == "") {
          uploadFiles[index].file = null;
          resolve();
        } else {
          uploadFiles[index].file = file;
          resolve();
        }
      })
    );
  });

  Promise.all(promiseArray).then(() => {
    callback({ ...uploadFiles });
  });
}

export function _createUpdateEventguide(
  maxDisplayorderVal,
  session,
  values,
  eventguide,
  dispatch,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/doc_faqs`;
  var eventguideJson = {};
  let iconImage = values.image ? values.image : "";
  var eventid = session.eventid;
  var iconfilename = `eventify/${eventid}/images/eventguides/${randomstring(
    32
  )}.jpg`;

  _uploadIcon(session, iconImage, iconfilename, dispatch, (icon) => {
    if (icon.success) {
      eventguideJson = {
        resource: {
          ...values,
          displayorder: maxDisplayorderVal,
          eventid: session.eventid,
          ...(icon.data && icon.data.path
            ? {
                image: icon.data.path,
              }
            : {}),
        },
      };
      if (eventguide.id) {
        patchRequest(
          url,
          eventguideJson,
          session,
          dispatch,
          (data) => {
            var eventguideid = data.resource[0].id;
            // Old Codes callback({ success: 1, id: id });
            callback({ success: 1, id: data.resource[0].id });
          },
          (error) => {
            callback({ success: 0, data: error });
          }
        );
      } else {
        postRequest(
          url,
          eventguideJson,
          session,
          dispatch,
          (data) => {
            var id = data.resource[0].id;
            callback({ success: 1, id: id });
          },
          (error) => {
            callback({ success: 0, data: error });
          }
        );
      }
    } else {
      callback({ success: 2 });
    }
  });
}

// Delete Event Guide
export function deleteEvent(session, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/doc_faqs/${id}`;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, response: response });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function getDispalyCategoryOrder(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventguide_admin_script`;
  return (dispatch) => {
    postRequest(
      url,
      {
        requesttype: "getcateorder",
        eventid: session.eventid,
        category: values.category,
      },
      session,
      dispatch,
      (response) => {
        callback({
          success: 1,
          response: response.resource.data.displaycategoryorder
            ? response.resource.data.displaycategoryorder
            : 1,
        });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}
export function _uploadIcon(session, imagedata, filename, dispatch, callback) {
  if (imagedata.search(";base64,") > 0) {
    imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, "");
    var imageJson = {
      resource: [
        {
          name: filename,
          type: "file",
          is_base64: true,
          content: imagedata,
        },
      ],
    };

    uploadEncodedFile(
      `${BASE_IMAGES_URL}?check_exist=false`,
      session,
      imageJson,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  } else {
    callback({ success: 1 });
  }
}
